import { render, staticRenderFns } from "./createDialog.vue?vue&type=template&id=bde5e1e4&scoped=true"
import script from "./createDialog.vue?vue&type=script&lang=js"
export * from "./createDialog.vue?vue&type=script&lang=js"
import style0 from "./createDialog.vue?vue&type=style&index=0&id=bde5e1e4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bde5e1e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-servicesplatform-fe/treasurenet-tnservices-servicesplatform-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bde5e1e4')) {
      api.createRecord('bde5e1e4', component.options)
    } else {
      api.reload('bde5e1e4', component.options)
    }
    module.hot.accept("./createDialog.vue?vue&type=template&id=bde5e1e4&scoped=true", function () {
      api.rerender('bde5e1e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/governance/proposal/createDialog.vue"
export default component.exports